import { useLayoutEffect } from 'react';
import { settings } from '../../core/settings/settings';
import { useSetting } from '../../core/settings/useSetting';

// Applies the theme setting: "auto" follows the device (no attribute, the
// stylesheet's prefers-color-scheme rule decides); light and dark are forced
// through data-theme on <html>. index.html sets the same attribute before the
// first paint so there is no flash.
export function useApplyTheme(): void {
    const [theme] = useSetting(settings.theme);

    useLayoutEffect(() => {
        const root = document.documentElement;
        if (theme === 'auto') {
            root.removeAttribute('data-theme');
        } else {
            root.setAttribute('data-theme', theme);
        }

        // Browser UI colour (address bar) follows the page background.
        const background = getComputedStyle(root).getPropertyValue('--bg').trim();
        if (background) {
            document.querySelector('meta[name="theme-color"]')?.setAttribute('content', background);
        }
    }, [theme]);
}
